import React, { createContext, useContext, useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const userData = localStorage.getItem("userData");

    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const login = async (authId, password) => {
    try {
      if (authId === "admin" && password === "admin123") {
        const mockUserData = {
          firstName: "debaswini",
          userName: "debaswini mishra",
          userId: "debaswinimishra_e042ed85",
          block: "BHUBANESWAR MC",
          blockCode: "211713",
          cluster: "GOVT. UPS, IRC VILLAGE, SECTOR - VI",
          clusterCode: "2117130010",
          district: "KHURDHA",
          districtCode: "2117",
          userCategory: "superadmin",
          userCode: "debaswinimishra001",
          userImage: "https://storage.googleapis.com/tz-bucket-0/profilePic_rn_i_a4a067e9-e.jpg?t=1768454848654",
          userLevel: "cluster",
          userType: "crcc",
          userPermissions: [
            // {
            //   app: "nipun_mis",
            //   navs: ["misDashboard", "misCot", "misSopan"]
            // },
            // {
            //   app: "nipun_report",
            //   navs: ["all"]
            // },
            {
              app: "chatbot_mis",
              navs: ["misDashboard", "chatbot_learning_outcomes", "chatbot_games", "templates", "threads"]
            },
            {
              app: "whatsapp_automation",
              navs: ["dashboard"]
            },
            {
              app: "whatsapp_automation_mis",
              // navs: ["server_status", "qr_scan", "groups", "admin_restricted_groups", "messages", "automation_template", "automation_media", "engagement_report"]
              // navs: ["server_status", "qr_scan", "groups", "admin_restricted_groups", "messages", "bulk_jobs", "automation_template", "automation_media", "engagement_report"]
              // navs: ["server_status", "qr_scan", "sync_servers", "groups", "admin_restricted_groups", "messages", "bulk_jobs", "automation_template", "automation_media", "engagement_report"]
              // navs: ["server_status", "messages", "bulk_jobs", "groups", "admin_restricted_groups", "qr_scan", "sync_servers", "automation_template", "automation_media", "engagement_report"]
              navs: ["server_status", "messages", "bulk_jobs", "most_active", "groups", "admin_restricted_groups", "sync_servers", "automation_template", "automation_media", "engagement_report"]
            },
            // {
            //   app: "orf_report",
            //   navs: ["dashboard", "raw_data", "version_data"]
            // },
            {
              app: "orf_mis",
              navs: ["dashboard", "user_register", "templates"]
            },
            {
              app: "prakashak_report",
              navs: ["dashboard"]
            },
            // {
            //   app: "binadidi_chatbot",
            //   navs: ["dashboard"]
            // }
          ]
        };

        const staticToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJtb25hbGlzYW1haGFyYW5hX2UwNDJlZDg1IiwiaWF0IjoxNzc3MzYwMDc5LCJleHAiOjE3Nzc0NDY0Nzl9.s7riSXDiIqfkdNwEQMls6B3dvr1nnAj0-roWovcecIA";

        localStorage.setItem("accessToken", staticToken);
        localStorage.setItem("userData", JSON.stringify(mockUserData));
        localStorage.setItem("role", mockUserData.userCategory);
        localStorage.setItem("usertype", mockUserData.userType);
        localStorage.setItem("districtname", mockUserData.district);
        setUser(mockUserData);

        return { success: true, data: mockUserData };
      } else {
        return { success: false, error: "Invalid credentials. Use admin / admin123" };
      }
    } catch (err) {
      console.error("Login error:", err);
      return { success: false, error: "Authentication failed" };
    }
  };
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("role");
    localStorage.removeItem("usertype");
    localStorage.removeItem("districtname");
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
